<template>
    <v-row>        
        <!-- <v-col cols="6" sm="12" md="12" class="py-0">
            <span class="subtitle-1 font-weight-bold">{{showMonth}}</span>
            &nbsp;
            <span class="subtitle-1 font-weight-bold">{{showYear}}</span>
        </v-col> -->
        <v-col v-if="1===0" class="hidden-md-and-up text-right py-0" cols="12" sm="12">
            <v-btn icon :disabled="canGoBack()" small @click="prevWeek()" large class=" mr-3"
                   style="font-size: 13px">
                <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
            <v-btn icon :disabled="canGoAhead()" small @click="nextWeek()" large class=""
                   style="font-size: 13px">
                <v-icon>mdi-chevron-right</v-icon>
            </v-btn>
        </v-col>
        <v-col cols="12" class="">
            <v-row align="center" justify="space-between" class="px-2">
                <v-btn icon :disabled="canGoBack()" small @click="prevWeek()" class=""
                           style="font-size: 13px">
                        <v-icon>mdi-chevron-left</v-icon>
                    </v-btn>
				
                <v-col class="subtitle-2 pb-0 pa-0 text-center" >                    
					
						<div class="d-flex justify-center " >
							<div class="d-flex justify-center" v-for="(n, i) in loopDays" :key="i" style="border-right:1px solid #efefef;flex-basis:0;flex-grow:1;padding-left:2px;padding-right:2px;">
								 <v-btn 
									v-if="$vuetify.breakpoint.mdAndUp"
									text
									depressed
									:class="addButtonClass(showWeekStart.clone().add(i,'days'))"
									
									class="weight-semibold pa-0 py-6"
									small 
									style="min-width:0px;width:100%"
									@click="selectDate(showWeekStart.clone().add(i,'days'))"
								 >
									<div class="font-10">{{ showWeekStart.clone().add(i,'days').format('ddd, MMM D') }}    </div>
								</v-btn>
								
								<v-btn 
								
									v-else
									text
									depressed
									:class="addButtonClass(showWeekStart.clone().add(i,'days'))"
									class="weight-semibold pa-0"
									small 
									style="min-width:0px;width:100%"
									@click="selectDate(showWeekStart.clone().add(i,'days'))"
								 >
									 <div class="d-flex flex-column">
										<div class="font-12">{{showWeekStart.clone().add(i,'days').format('dd')}}    </div>
										<div class="font-8">{{showWeekStart.clone().add(i,'days').format('D, MMM')}}    </div>
									 </div>
																						
								</v-btn>
								
							</div>
						</div>
					
                                        
                </v-col>
                <v-btn icon :disabled="canGoAhead()" small @click="nextWeek()" class=""
                           style="font-size: 13px">
                        <v-icon>mdi-chevron-right</v-icon>
                    </v-btn>
            </v-row>
        </v-col>
    </v-row>
</template>
<script>
    export default {
        name: "DatePicker",
        watch: {},
		props: ['default_date'],
        methods: {
		isSameDay(value){
				
                return value.format('YYYY-MM-DD') == this.returnDate
			},
		showSmallWeekday(value) {
                let year = this === undefined ? this.moment().format('YYYY') + '-01-01 00:00:00' : this.showYear + '-01-01 00:00:00'
                return this.moment(year).dayOfYear(value).format('dd')
            },
			showDateMonth(value) {
                let year = this === undefined ? this.moment().format('YYYY') + '-01-01 00:00:00' : this.showYear + '-01-01 00:00:00'
                return this.moment(year).dayOfYear(value).format('D, MMM')
            },
            showWeekDayMonth(value) {
                let year = this === undefined ? this.moment().format('YYYY') + '-01-01 00:00:00' : this.showYear + '-01-01 00:00:00'
                return this.moment(year).dayOfYear(value).format('ddd, MMM D')
            },
            showDayName(value) {
                let year = this === undefined ? this.moment().format('YYYY') + '-01-01 00:00:00' : this.showYear + '-01-01 00:00:00'
                return this.moment(year).dayOfYear(value).format('ddd')
            },
            showDayNumber(value) {
                let year = this === undefined ? this.moment().format('YYYY') + '-01-01 00:00:00' : this.showYear + '-01-01 00:00:00'
                return this.moment(year).dayOfYear(value).format('D')
            },
            isToday(dayNo) {
                return this.moment(this.showYear).dayOfYear(dayNo).format('YYYY-MM-DD') === this.today.format('YYYY-MM-DD')
            },
            updateMonth() {
                let monthNumber = this.moment().month(this.showMonth).format("MM")
                if (this.todayMonthNumber >= monthNumber) {
                    this.showWeekStart = this.moment(this.yearList[0] + '-' + monthNumber + '-01').startOf('week')
                } else {
                    this.showWeekStart = this.moment(this.yearList[1] + '-' + monthNumber + '-01').startOf('week')
                }
                if (this.showWeekStart.format('D') !== '1') {
                    this.showWeekStart.add(1, 'week')
                }
                this.updateCalendar()
            },
            updateYear() {
                this.showWeekStart = this.moment(this.showYear + '-01-01') < this.minWeekStart ? this.minWeekStart : this.moment(this.showYear + '-01-01').startOf('week')
                if (this.showWeekStart.format('D') !== '1' && this.showWeekStart !== this.minWeekStart) {
                    this.showWeekStart.add(1, 'week')
                }
                this.updateCalendar()
            },
			canSelect(value){
				let date = value.clone()
                if (date >= this.minWeekStart) {
                    if (this.today <= date) {
                        return true;
                    }
					else
						return false;
                } else {
                    return true;
                }
			},
			addButtonClass(date){
				var classes = "date-buttons";
				if(!this.canSelect(date))
					classes = classes.concat(' disabled-btn')
				classes = classes.concat(this.isSameDay(date) ? ' selected-date primary--text': ' white darkergray--text')
				return classes;
			},
            selectDate(value) {
                let date = value.clone()
                if (date >= this.minWeekStart) {
                    if (this.today <= date) {
                        this.selectedDay = value
                        this.returnDate = date.format('YYYY-MM-DD')
                    }
                } else {
                    this.selectedDay = value
                    date = this.moment(this.yearList[1]).dayOfYear(value)
                    this.returnDate = date.format('YYYY-MM-DD')
                }
                this.$emit('input', this.returnDate)
            },
            canGoAhead() {
                let toDate = this.moment(this.showYear + '-01-01 00:00:00').dayOfYear(this.showWeekStartDay)
                return !(this.maxWeekStart > toDate.add(this.loopDays, 'days'))
            },
            canGoBack() {
                let toDate = this.moment(this.showYear + '-01-01 00:00:00').dayOfYear(this.showWeekStartDay)
                return !(this.minWeekStart <= toDate.subtract(this.loopDays, 'days'))
            },
            nextWeek() {
                this.showWeekStart.add(this.loopDays, 'days')
                this.updateCalendar()
            },
            prevWeek() {
                this.showWeekStart.subtract(this.loopDays, 'days')
                this.updateCalendar()
            },
            updateCalendar() {
                this.showWeekStartDay = this.showWeekStart.dayOfYear()
                this.showMonth = this.showWeekStart.format('MMMM')
                this.showYear = this.showWeekStart.format('YYYY')
            },
            setDefaultDates() {
                var cur_moment=this.moment()
                 if(this.default_date != undefined){                    
                     cur_moment = this.moment(this.default_date,"YYYY-MM-DD")
					 
                     this.selectedDay = cur_moment.dayOfYear();
                 }
                
                //this.selectedDay = this.moment().dayOfYear();
                
                this.todayMonthNumber = this.moment().format("M");
                var today_moment = this.moment()
                this.today = today_moment.startOf('day');
                this.showMonth = cur_moment.format('MMMM');
                this.showYear = cur_moment.format('YYYY');
                this.showWeekStartDay = cur_moment.clone().startOf('week').dayOfYear();
                this.monthList = this.moment.months();
                this.yearList = [this.moment().format('YYYY'), this.moment().add(1, 'year').format('YYYY')];
                this.showWeekStart = cur_moment.clone().startOf('week');
                this.minWeekStart = this.moment().startOf('week');
                this.maxWeekStart = this.moment().add(11, 'months').endOf('month');
                this.returnDate = cur_moment.format('YYYY-MM-DD');
				this.$emit('input', this.returnDate)
				
                if (this.$vuetify.breakpoint.mdAndUp) {
                    this.loopDays = 7
                }
                

            }
        },
        data() {
            return {
                loopDays: 5,
                todayMonthNumber: null,
                selectedDay: null,
                today: null,
                showMonth: null,
                showYear: null,
                showWeekStartDay: null,
                monthList: null,
                yearList: null,
                showWeekStart: null,
                minWeekStart: null,
                maxWeekStart: null,
                returnDate: null,
            }
        },
        created() {
            this.setDefaultDates();
        },
        mounted() {
            this.showMonth = this.moment().dayOfYear(this.selectedDay).format('MMMM')
            let thisMonthIndex = this.monthList.indexOf(this.showMonth)
            if (thisMonthIndex > 0) {
                let x = this.monthList.splice(0, thisMonthIndex)
                this.monthList = this.monthList.concat(x)
            }
            this.$emit('input', this.returnDate)
        }
    }
</script>
<style scoped>
    .date-buttons {
        transition: 200ms all linear;
    }
    .selected-date{
        background-color:rgba(219, 0, 0, 0.10) !important;
    }
	
	.disabled-btn{
		opacity:0.4;
	}
</style>
